export default "__VITE_ASSET__Di0p1hdW__"